import { AxiosResponse } from 'axios';

import store from '@store/store';
import api from '@core/services/api';
import { downloadFile } from '@core/utils/pdf.utils';
import { IBancoHoras, IInformeRendimentos, IHolerite, IUser, IPeriodoFerias, IDetalhePeriodoFerias, IDetalheFerias, IBeneficiosVt, IBeneficiosVaVr, IBeneficiosPlanoSaude } from '@core/models';
import { colaborador_error, colaborador_fetching, colaborador_success } from '@core/slice/colaborador.slice';
import { holerite_error, holerite_fetching, holerite_success } from '@core/slice/holerite.slice';
import { banco_horas_error, banco_horas_fetching, banco_horas_success } from '@core/slice/banco-horas.slice';
import { informe_rendimentos_error, informe_rendimentos_fetching, informe_rendimentos_success } from '@core/slice/informe-rendimentos.slice';
import { download_rendimentos_error, download_rendimentos_fetching, download_rendimentos_success } from '@core/slice/download-rendimentos.slice';
import { periodoFerias_error, periodoFerias_fetching, periodoFerias_success } from '@core/slice/periodoFerias.slice';
import { detalhePeriodoFerias_error, detalhePeriodoFerias_fetching, detalhePeriodoFerias_success } from '@core/slice/detalhePeriodoFerias.slice';
import { detalheFerias_error, detalheFerias_fetching, detalheFerias_success } from '@core/slice/detalheFerias.slice';
import { beneficiosVt_error, beneficiosVt_fetching, beneficiosVt_success } from '@core/slice/beneficiosVt.slice';
import { beneficiosVaVr_error, beneficiosVaVr_fetching, beneficiosVaVr_success } from '@core/slice/beneficiosVaVr.slice';

import { beneficiosPlanoSaude_error, beneficiosPlanoSaude_fetching, beneficiosPlanoSaude_success } from '@core/slice/beneficiosPlanoSaude.slice';

class ColaboradorService {
    buscarColaborador() {
        store.dispatch(colaborador_fetching());

        api.get<IUser>('api/auth/ficha-basica')
            .then((response: AxiosResponse<IUser>) => {
                store.dispatch(colaborador_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(colaborador_error(e.response?.data?.message || 'Erro ao buscar os dados do colaborador.'));
            });
    }

    buscarHolerite(tipoHolerite: any, dataCompetencia: string) {
        store.dispatch(holerite_fetching());

        api.get<IHolerite>(`/api/colaborador/holerite?tipoCalculo=${tipoHolerite}&mesCompetencia=${dataCompetencia}`)
            .then((response: AxiosResponse<IHolerite>) => {
                store.dispatch(holerite_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(holerite_error(e.response?.data?.message || 'Erro ao buscar os dados do holerite.'));
            });
    }

    buscarBancoHoras(dataCompetencia: string) {
        store.dispatch(banco_horas_fetching());

        api.get<IBancoHoras>(`/api/colaborador/banco-horas?mesCompetencia=${dataCompetencia}`)
            .then((response: AxiosResponse<IBancoHoras>) => {
                store.dispatch(banco_horas_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(banco_horas_error(e.response?.data?.message || 'Erro ao buscar os dados de banco de horas.'));
            });
    }

    buscarInformesRendimentos() {
        store.dispatch(informe_rendimentos_fetching());

        api.get<IInformeRendimentos>('/api/colaborador/comprovante-rendimentos')
            .then((response: AxiosResponse<IInformeRendimentos>) => {
                store.dispatch(informe_rendimentos_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(informe_rendimentos_error(e.response?.data?.message || 'Erro ao listar os informes de rendimentos.'));
            });
    }

    baixarInformeRendimentos(dataReferencia: string) {
        store.dispatch(download_rendimentos_fetching());

        api.get(`/api/colaborador/comprovante-rendimentos/baixar?dataReferencia=${dataReferencia}`, {
            responseType: 'blob'
        })
            .then((response: AxiosResponse) => {
                downloadFile(response.data, 'informe-rendimentos');
                store.dispatch(download_rendimentos_success('Informe de rendimentos gerado com sucesso.'));
            })
            .catch((e: any) => {
                store.dispatch(download_rendimentos_error(e.response?.data?.message || 'Erro baixar o informe de rendimentos.'));
            });
    }

    buscarPeriodoFerias() {
        store.dispatch(periodoFerias_fetching());

        api.get<IPeriodoFerias[]>('/api/colaborador/ferias')
            .then((response: AxiosResponse<IPeriodoFerias[]>) => {
                store.dispatch(periodoFerias_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(periodoFerias_error(e.response?.data?.message || 'Erro ao listar as férias.'));
            });
    }

    detalhePeriodoFerias(inicioPeriodo: string, fimPeriodo: string) {
        store.dispatch(detalhePeriodoFerias_fetching());

        api.get<IDetalhePeriodoFerias[]>(`/api/colaborador/ferias/detalhe?inicioPeriodo=${inicioPeriodo}&fimPeriodo=${fimPeriodo}`)
            .then((response: AxiosResponse<IDetalhePeriodoFerias[]>) => {
                store.dispatch(detalhePeriodoFerias_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(detalhePeriodoFerias_error(e.response?.data?.message || 'Erro ao carregar os detalhes do período.'));
            });
    }

    detalheFerias(inicioPeriodo: any, inicioFerias: string) {
        store.dispatch(detalheFerias_fetching());

        api.get<IDetalheFerias>(`/api/colaborador/ferias/recibo?inicioPeriodo=${inicioPeriodo}&inicioFerias=${inicioFerias}`)
            .then((response: AxiosResponse<IDetalheFerias>) => {
                store.dispatch(detalheFerias_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(detalheFerias_error(e.response?.data?.message || 'Erro ao buscar os dados do holerite.'));
            });
    }

    beneficiosVt() {
        store.dispatch(beneficiosVt_fetching());

        api.get<IBeneficiosVt[]>('api/colaborador/beneficio/vale-transporte')
            .then((response: AxiosResponse<IBeneficiosVt[]>) => {
                store.dispatch(beneficiosVt_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(beneficiosVt_error(e.response?.data?.message || 'Erro ao buscar os dados do vale transporte.'));
            });
    }

    beneficiosVaVr() {
        store.dispatch(beneficiosVaVr_fetching());

        api.get<IBeneficiosVaVr>('api/colaborador/beneficio/va-vr')
            .then((response: AxiosResponse<IBeneficiosVaVr>) => {
                store.dispatch(beneficiosVaVr_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(beneficiosVaVr_error(e.response?.data?.message || 'Erro ao buscar os dados do vale alimentação/refeição.'));
            });
    }

    beneficiosPlanoSaude(dataCompetencia: string) {
        store.dispatch(beneficiosPlanoSaude_fetching());

        api.get<IBeneficiosPlanoSaude>(`/api/colaborador/beneficio/plano-saude?mesCompetencia=${dataCompetencia}`)
            .then((response: AxiosResponse<IBeneficiosPlanoSaude>) => {
                store.dispatch(beneficiosPlanoSaude_success(response.data));
            })
            .catch((e: any) => {
                store.dispatch(beneficiosPlanoSaude_error(e.response?.data?.message || 'Erro ao buscar os dados do plano de saúde.'));
            });
    }
}
export const colaboradorService: ColaboradorService = new ColaboradorService();
